import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import { TID } from "@/lib/testIds";
import { ShieldCheck, Layers3, Globe, Lightbulb, Hammer, Handshake } from "lucide-react";

const ICONS = [ShieldCheck, Layers3, Globe, Lightbulb, Hammer, Handshake];

export default function WhySection() {
  const { t } = useI18n();
  const items = t("why.items");

  return (
    <section
      data-testid={TID.why}
      className="relative bg-white py-24 md:py-32"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <p className="gc-eyebrow">{t("why.eyebrow")}</p>
          <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight font-[700] text-[color:var(--gc-ink)]">
            {t("why.title")}
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[color:var(--gc-line)] border border-[color:var(--gc-line)]">
          {Array.isArray(items) &&
            items.map((it, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: (i % 3) * 0.06 }}
                  className="relative bg-white p-8 lg:p-10 group hover:bg-[color:var(--gc-paper)] transition-colors"
                >
                  <div className="flex items-start justify-between">
                    <Icon className="w-7 h-7 text-[color:var(--gc-ink)]" strokeWidth={1.4} />
                    <span className="font-mono text-[11px] tracking-[0.18em] text-[color:var(--gc-mist)]">
                      0{i + 1}
                    </span>
                  </div>
                  <h3 className="mt-10 font-display text-xl lg:text-2xl font-[700] tracking-tight text-[color:var(--gc-ink)] leading-tight">
                    {it.t}
                  </h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-[color:var(--gc-steel)]">
                    {it.d}
                  </p>
                  <span className="absolute left-0 bottom-0 h-[2px] w-0 bg-[color:var(--gc-red)] group-hover:w-full transition-all duration-500" />
                </motion.div>
              );
            })}
        </div>
      </div>
    </section>
  );
}
